// packages import
import { Box, Divider, List, Stack, Typography } from '@mui/material'
import moment from 'moment'
import { forwardRef } from 'react'
// others
import { ExternalUserRoleRole } from '../../../generated'
import { NOT_APPLICABLE, STANDARD_DATE_FORMAT } from '../../constants'
import { PrintTasksProps } from '../../interfaceTypes'
import { titleize } from '../../utils'

export const PrintTasks = forwardRef<HTMLUListElement, PrintTasksProps>(function ListBoxBase(props, ref) {
  const { sortedEvents, selectedUser } = props
  const { firstName, roles, lastName } = selectedUser || {}
  const fullName = `${firstName || ''} ${lastName || ''}`

  return (
    <Box ref={ref}>
      <style>{`@media print { @page {  margin: 20mm 15mm; }}`}</style>

      <Stack direction="row" gap="10px">
        <Typography variant="body2" component="span">
          Name:
        </Typography>
        <Typography>{fullName}</Typography>
      </Stack>

      <Stack direction="row" gap="10px">
        <Typography variant="body2" component="span">
          Role:
        </Typography>
        <Typography>{roles?.map(role => titleize(role?.role || ''))}</Typography>
      </Stack>

      <Divider sx={{ marginBottom: 2, marginTop: 1 }} />

      <List ref={ref}>
        {sortedEvents &&
          sortedEvents.map(taskItem => {
            const { task, litigation, followUpDate } = taskItem || {}
            const { id, title } = task || {}
            const { title: caseTitle, caseNumber, caseToExternalUserToExternalUserRole } = litigation || {}
            const client = caseToExternalUserToExternalUserRole?.find(
              item =>
                item?.externalUserToExternalUserRole?.externalUser?.externalUserRoles &&
                item?.externalUserToExternalUserRole?.externalUser?.externalUserRoles[0]?.externalUserRole?.role ===
                  ExternalUserRoleRole.Client
            )?.externalUserToExternalUserRole.externalUser
            const { firstName: clientFirstName, lastName: clientLastName } = client || {}
            const clientFullName =
              clientFirstName || clientLastName ? `${clientFirstName} ${clientLastName}` : NOT_APPLICABLE

            return (
              <>
                <Stack direction="row" key={id} justifyContent="space-between" alignItems="center" my={1}>
                  <Box>
                    <Typography>{titleize(title || '')}</Typography>
                    <Typography fontWeight={500} fontSize="14px" paddingRight="5px">
                      {`(#${caseNumber} ${caseTitle}) `}
                      {clientFullName}
                    </Typography>
                  </Box>

                  <Typography fontWeight={500} mr={1}>
                    {moment(followUpDate).format(STANDARD_DATE_FORMAT)}
                  </Typography>
                </Stack>
                <Divider />
              </>
            )
          })}
      </List>
    </Box>
  )
})
